import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    open: translate({ id: 'sms4.trackingPagePreviewModal.actions.open' }),
    cancel: translate({ id: 'sms4.trackingPagePreviewModal.actions.cancel' }),
    cardText: translate({ id: 'sms4.trackingPagePreviewModal.card.text' }),
  }))

  return api
}
